import { render, staticRenderFns } from "./UserProfileDropDown.vue?vue&type=template&id=ff5eb7e0&"
import script from "./UserProfileDropDown.vue?vue&type=script&lang=js&"
export * from "./UserProfileDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports